<!--设备台账-->
<template>
  <div class="newarchives">
    <div class="con">
      <div class="search-input-btn">
        <el-scrollbar style="height:100%;width: 100%;">
          <div class="my-search-i">
            <div class="input-small">
              <span>设备名：</span>
              <el-input v-model="deviceName" clearable placeholder="请输入名称"></el-input>
            </div>
            <div class="input-small" style="margin:0px 20px;">
              <span>日期：</span>
              <el-date-picker v-model="dateTimer" type="daterange" align="right" unlink-panels range-separator="至"
                start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
              </el-date-picker>
            </div>
            
            <div class="input-small myinput">
              <span>类型：</span>
              <el-select v-model="typeEnum" placeholder="请选择" clearable style="width:1.6rem">
                <el-option v-for="item in typeEnumList" :key="item.value" :label="item.name" :value="item.value">
                </el-option>
              </el-select>
            </div>
            
            <el-button type="primary" size="mini" plain @click="getList" class="search-btn">查询</el-button>
          </div>
        </el-scrollbar>


      </div>
      <div class="mytable" :style="{'height':heights+'px'}">
        <el-table id="demo" :height="heights - 20" border stripe :data="tableData" style="width: 100%">
          <template slot="empty">
            <span class="noData">
              <img src="@/assets/noData.png" alt="暂无数据">
              <span class="text">暂无数据</span>
            </span>
          </template>
          <el-table-column label="序号" width="90" align="center">
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="deviceName" label="设备名"> </el-table-column>
          <el-table-column prop="deviceNo" label="设备编号"> </el-table-column>
         
          <el-table-column label="操作类型" align="center">
            <template #default="{row}">
              <div class="state-row close-state" v-if="row.operationType=='ENABLE'">
                <span></span>分
              </div>
              <div class="state-row open-state" v-else>
                <span></span>合
              </div>
            </template>
          </el-table-column>
          <el-table-column label="持续时间">
            <template slot-scope="scope"><span>{{ scope.row.durationTime | formatMilliseconds}}</span></template>
          </el-table-column>
          <el-table-column label="操作时间">
            <template slot-scope="scope"><span>{{ scope.row.createTime | date_format}}</span></template>
          </el-table-column>
        </el-table>
      </div>
      <div class="divider-line"></div>
      <div class="paging">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
          :current-page="currentPage" :page-sizes="[15, 25, 35, 45, 55]" :page-size="15"
          layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>

    </div>

  </div>
</template>

<script type="text/javascript">
import {findAllByPagecontrol} from "../../api/abbNewApi";
  export default {
    components: {

    },
    props: [],
    data () {
      return {
        heights: document.getElementById('app').clientHeight-250,
        tableData: [],
        deviceName: "",
        dateTimer: null,
        currentPage: 1,
        currentSize: 15,
        total: 0,
        typeEnum: "",
        typeEnumList: [
          {
            name: '开闸',
            value: 'ENABLE',
          },
          {
            name: '合闸',
            value: 'DISABLE',
          }
        ],
        IPAddress: "",
        stateEnum: "",
        

        pickerOptions: {
          disabledDate (time) {
            return time.getTime()>Date.now();
          },
          shortcuts: [
            {
              text: '最近一周',
              onClick (picker) {
                const end=new Date();
                const start=new Date();
                start.setTime(start.getTime()-3600*1000*24*7);
                picker.$emit('pick',[start,end]);
              }
            },{
              text: '最近一个月',
              onClick (picker) {
                const end=new Date();
                const start=new Date();
                start.setTime(start.getTime()-3600*1000*24*30);
                picker.$emit('pick',[start,end]);
              }
            },{
              text: '最近三个月',
              onClick (picker) {
                const end=new Date();
                const start=new Date();
                start.setTime(start.getTime()-3600*1000*24*90);
                picker.$emit('pick',[start,end]);
              }
            }]
        },
      }
    },
    created () {

    },
    mounted () {
      this.getList()
    },
    destroyed () {},
    computed: {

    },
    methods: {
      
      getList () {
        var d  = {
             "pageNum": this.currentPage,
             "pageSize": this.currentSize,
             "operationType":this.typeEnum,
             'deviceName':this.deviceName
        }
       
        for(let key in d) {
          if(d[key]==='') {
            delete d[key];
          }
        }

        if(this.dateTimer) {
          d.startTime=this.dateTimer[0].getTime()
          d.endTime=this.dateTimer[1].getTime()
        }
         findAllByPagecontrol(d).then(res => {
            console.log("获取",res);
           if(res.code==200) {
            this.tableData=res.data.content
            this.total=res.data.totalElements;
          } else {
            res.message? this.$message({message: res.message,type: 'error'}):this.$message({message: '请求失败，请检查配置！！',type: 'error'})
          }
        })
        
      },

      //分页功能 
      handleSizeChange (val) {
        this.currentSize=val;
        this.getList()
      },
      handleCurrentChange (val) {
        this.currentPage=val;
        this.getList()
      }

    },
    filters: {

      // 转换时间戳
      date_format (value) { //value就是插值的数据
        if(!value) {
          return ""
        }
        let date=new Date(value);
        let Y=date.getFullYear()+'-';
        let M=(date.getMonth()+1<10? '0'+(date.getMonth()+1):date.getMonth()+1)+'-';
        let D=(date.getDate()<10? '0'+(date.getDate()):date.getDate())+' ';

        let h=(date.getHours()<10? '0'+(date.getHours()):date.getHours())+':';
        let m=(date.getMinutes()<10? '0'+(date.getMinutes()):date.getMinutes())+':';
        let s=(date.getSeconds()<10? '0'+(date.getSeconds()):date.getSeconds());
        let strDate=Y+M+D+h+m+s;
        return strDate
      },
      //转换时间 举例：将 123456789 毫秒转换为几天几时几分几秒
      formatMilliseconds(milliseconds) {
           // 一天的毫秒数
            const oneDay = 24 * 60 * 60 * 1000;
            // 一小时的毫秒数
            const oneHour = 60 * 60 * 1000;
            // 一分钟的毫秒数
            const oneMinute = 60 * 1000;

            // 计算天数
            const days = Math.floor(milliseconds / oneDay);
            // 计算剩余小时数
            const hours = Math.floor((milliseconds % oneDay) / oneHour);
            // 计算剩余分钟数
            const minutes = Math.floor((milliseconds % oneHour) / oneMinute);
            // 计算剩余秒数
            const seconds = Math.floor((milliseconds % oneMinute) / 1000);
            return `${days}天${hours}时${minutes}分${seconds}秒`
           
      },
    }
  }
</script>
<style scoped lang="scss">
  .newarchives {
    .con {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      padding: 12px 20px;
      //  display: flex;
      background-color: #fff;

      .search-input-btn {
        width: 100%;
        height: 36px;

        .my-search-i {
          width: 100%;
          display: flex;
          align-items: center;
        }
      }

      .paging {
        display: flex;
        justify-content: flex-end;
        margin-top: 15px;
      }

      .state-row {
        display: flex;
        justify-content: center;
        align-items: center;

        span {
          display: inline-block;
          width: 9px;
          height: 9px;
          border-radius: 50%;
          margin-right: 10px;
          position: relative;
          top: -1px;
          border: 3px solid transparent;
        }
      }

      .open-state {
        color: #0DAE88;

        span {
          background-color: #0DAE88;
          border-color: #B0FFED;
        }
      }

      .close-state {
        color: #FF1D1D;

        span {
          background-color: #FF1D1D;
          border-color: #FFD7D7;
        }
      }

    }
  }
</style>